exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___1MTQV{text-align:center}.style__header___2UWkf{position:relative;display:inline-block;font-family:PlayfairDisplay-Regular;font-size:60px;letter-spacing:2px;color:#333;font-weight:300;text-align:center;margin:0}.style__subtitle___3BZf4{font-family:Poppins-Light;font-size:17px;font-weight:300;line-height:1.8;letter-spacing:.6px;text-align:center;color:#333}", ""]);

// exports
exports.locals = {
	"container": "style__container___1MTQV",
	"header": "style__header___2UWkf",
	"subtitle": "style__subtitle___3BZf4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/header/style.css
// module id = 679
// module chunks = 0